var quizQuestions = [
  {
    question: "Is drinking making your home life unhappy?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Does your drinking make you careless of your family’s welfare?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Do you drink because you are shy with other people?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Is drinking affecting your reputation?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Do you drink to escape from worries or trouble?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Do you drink alone?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Have you lost time from work due to drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Has your ambition decreased since drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Has your efficiency decreased since drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Is drinking jeopardising your job or business?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Have you ever felt remorse after drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Are you in financial difficulties as a result of drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Do you turn to or seek an inferior environment when drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Do you crave a drink at a definite time daily?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Does drinking cause you to have difficulty in sleeping?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Do you want a drink the next morning?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Do you drink to build up your self-confidence?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question:
      "Have you ever had a complete loss of memory as a result of drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Has your doctor ever treated you for drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  },
  {
    question: "Have you ever been in hospital or prison because of drinking?",
    answers: [
      {
        type: "Yes",
        content: "Yes"
      },
      {
        type: "No",
        content: "No"
      }
    ]
  }
];

export default quizQuestions;



// WEBPACK FOOTER //
// ./src/api/quizQuestions.js